import { TRANSACTION_TYPE_LABELS, TRANSACTION_TYPE_COLORS } from '../types';

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatDateTime = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getTransactionTypeColor = (type: string | number): string => {
  const typeNumber = typeof type === 'string' ? parseInt(type) : type;
  return TRANSACTION_TYPE_COLORS[typeNumber] || '#9e9e9e';
};

export const getTransactionTypeLabel = (type: string | number): string => {
  const typeNumber = typeof type === 'string' ? parseInt(type) : type;
  return TRANSACTION_TYPE_LABELS[typeNumber] || 'Unknown';
};

export const getTransactionTypeInfo = (type: string | number) => {
  const typeNumber = typeof type === 'string' ? parseInt(type) : type;
  return {
    label: TRANSACTION_TYPE_LABELS[typeNumber] || 'Unknown',
    color: TRANSACTION_TYPE_COLORS[typeNumber] || '#9e9e9e',
  };
};